/** Titres martiaux FR/EN — BT-028-R3. */

const MARTIAL_TITLES_FR = [
  {
    titre: "Grand Master",
    niveau: "Direction historique",
    description: "Direction fondateur de l'organisation — référence symbolique et protocolaire.",
  },
  {
    titre: "Hanshi",
    niveau: "Instructeur chef",
    description: "Responsable martial global de l'organisation — coordonne les dojos et valide les contenus sensibles.",
  },
  {
    titre: "Kyoshi",
    niveau: "Maître enseignant",
    description: "Grade élevé d'enseignement — leadership senior au sein de l'organisation.",
  },
  {
    titre: "Shihan",
    niveau: "Maître instructeur",
    description: "Instructeur senior — peut superviser plusieurs dojos ou programmes.",
  },
  {
    titre: "Renshi",
    niveau: "Instructeur poli",
    description: "Instructeur reconnu au sein de l'organisation — progression dans l'enseignement.",
  },
  {
    titre: "Sensei",
    niveau: "Responsable de dojo",
    description: "Un Sensei par dojo — responsable des étudiants et du fonctionnement local.",
  },
  {
    titre: "Sempai / Assistant",
    niveau: "Soutien",
    description: "Aide à l'enseignement sous supervision du Sensei.",
  },
];

const MARTIAL_TITLES_EN = [
  {
    titre: "Grand Master",
    niveau: "Historical leadership",
    description: "Founding direction of the organisation — symbolic and protocol reference.",
  },
  {
    titre: "Hanshi",
    niveau: "Chief instructor",
    description: "Global martial lead — coordinates dojos and validates sensitive content.",
  },
  {
    titre: "Kyoshi",
    niveau: "Master teacher",
    description: "Senior teaching grade — senior leadership within the organisation.",
  },
  {
    titre: "Shihan",
    niveau: "Master instructor",
    description: "Senior instructor — may supervise multiple dojos or programmes.",
  },
  {
    titre: "Renshi",
    niveau: "Polished instructor",
    description: "Recognised instructor within the organisation — teaching progression.",
  },
  {
    titre: "Sensei",
    niveau: "Dojo lead",
    description: "One Sensei per dojo — responsible for students and local operations.",
  },
  {
    titre: "Sempai / Assistant",
    niveau: "Support",
    description: "Assists teaching under Sensei supervision.",
  },
];

const LEADERSHIP_NOTE_FR =
  "Noms et titres issus du document BlackDragon2026 reçu. Les associations dojo ↔ Sensei ne sont pas inventées — elles seront confirmées avec le fichier client.";

const LEADERSHIP_NOTE_EN =
  "Names and titles come from the received BlackDragon2026 document. Dojo ↔ Sensei links are not invented — they will be confirmed with the client file.";

/** @param {'fr'|'en'} locale */
export function getMartialTitles(locale = "fr") {
  return locale === "en" ? MARTIAL_TITLES_EN : MARTIAL_TITLES_FR;
}

/** @param {'fr'|'en'} locale */
export function getLeadershipNote(locale = "fr") {
  return locale === "en" ? LEADERSHIP_NOTE_EN : LEADERSHIP_NOTE_FR;
}
